export default __webpack_public_path__ + "static/media/Medium's Boots of the Emissary.9eed80aa.jpg";